import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Footer from "../components/Footer";
import Icon from "../components/Icon";
import { grantPaidUnlock } from "../utils/paidUnlock";
import { PRICING } from "../config/pricing";
import { setPageMeta } from "../utils/meta";

/**
 * The Stripe Payment Link success return.
 *
 * Stripe redirects here after payment. With no server there is no signed
 * proof to verify (see config/pricing.js), so arriving here IS the grant —
 * a deliberate soft gate. We store the unlock, then send the buyer back to
 * where they started (or the light-meter page) so they can use it.
 *
 * noindex: this is a transactional endpoint, not content.
 */
export default function Unlock() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  // Stripe passes client_reference_id back through; we used it to carry the
  // origin page. Fall back to the analyzer entry.
  const ref = params.get("client_reference_id");
  const returnTo = (ref && decodeURIComponent(ref)) || params.get("from") || "/light-meter";

  useEffect(() => {
    setPageMeta({
      title: "Unlocking…",
      description: "Completing your Scene Analysis unlock.",
      noindex: true,
      follow: false,
    });

    grantPaidUnlock();
    setDone(true);

    // Give the confirmation a beat to render, then return the buyer.
    const safeReturn = returnTo.startsWith("/") ? returnTo : "/light-meter";
    const t = setTimeout(() => navigate(safeReturn, { replace: true }), 2200);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="unlock-page">
      <div className="unlock-card panel">
        <span className="unlock-icon" aria-hidden="true"><Icon name="aperture" size={30} /></span>
        <h1>{done ? "Scene Analysis unlocked" : "Unlocking…"}</h1>
        <p>
          {done
            ? "You're all set. Taking you back so you can use it, open a recipe on your phone to measure the light and your pan speed."
            : "One moment while we complete your unlock."}
        </p>
        <p className="unlock-manual">
          Not redirected? <Link to="/light-meter">Continue →</Link>
        </p>
      </div>

      <div data-prerender-ready="true" style={{ display: "none" }} />
      <Footer />
    </main>
  );
}
